import { Typography, Grid, Stack } from '@mui/material';

import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { ReactComponent as DashboardIcon } from 'common/assets/images/dashboard.svg';
import ButtonComp from 'common/components/Button/ButtonComp';
import { BUTTON_LABELS } from 'common/constants';
import { FeatureFlagsKeysEnum } from 'common/constants/FeatureFlags';
import {
	APP_RISK_LINK_DASHBOARD_CONSTANT,
	APP_RISK_LINK_DASHBOARD_DESCRIPTION,
} from 'common/constants/TextContent';
import { RootState } from 'common/store/AppStore';

import { useFeatureFlag } from 'hooks/useFeatureFlags';

import styles from './DashboardBanner.module.scss';

const { imageColor } = styles;

const DashboardBanner = () => {
	const [loggedInUserName, setLoggedInUserName] = useState<string>('');
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const isHomePageGetStartedButtonEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_HOME_PAGE_GET_STARTED_BUTTON_ENABLED,
	);
	const isHomePageLatestUpdatesButtonEnabled = useFeatureFlag(
		FeatureFlagsKeysEnum.IS_HOME_PAGE_LATEST_UPDATES_BUTTON_ENABLED,
	);

	useEffect(() => {
		if (loggedInUser) {
			const userName = loggedInUser?.firstName || '';
			setLoggedInUserName(userName);
		}
	}, [loggedInUser]);
	return (
		<Grid container>
			<div>
				<Grid item p={2}>
					<Stack direction="row" spacing={1} alignItems="center">
						<DashboardIcon fill={imageColor} />
						<Typography
							className={styles['dashboard-banner-main-text']}
							mb={1}
						>{`${APP_RISK_LINK_DASHBOARD_CONSTANT}, ${loggedInUserName}`}</Typography>
					</Stack>
					<Typography
						className={styles['dashboard-banner-main-text-decs']}
						mb={1}
						pr={3}
					>
						{APP_RISK_LINK_DASHBOARD_DESCRIPTION}
					</Typography>

					<Stack direction="row" spacing={2} mb={1}>
						{isHomePageGetStartedButtonEnabled && (
							<ButtonComp btnType="primary" data-testid="getstarted-btn">
								{BUTTON_LABELS.GET_STARTED}
							</ButtonComp>
						)}
						{isHomePageLatestUpdatesButtonEnabled && (
							<ButtonComp btnType="text" data-testid="latestupdate-btn">
								{BUTTON_LABELS.LATEST_UPDATES}
							</ButtonComp>
						)}
					</Stack>
				</Grid>
			</div>
		</Grid>
	);
};

export default DashboardBanner;
